import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "df-impact"
};
const _hoisted_2 = { class: "df-impact__text" };
import { computed } from "vue";
import { useDonation } from "../../context/donationContext";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ImpactStatement',
    setup(__props) {
        // SYNC: see ../../_SYNC.md.
        const { presets } = useDonation();
        const description = computed(() => presets.value.find((p) => p.selected)?.description ?? null);
        return (_ctx, _cache) => {
            return (description.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _cache[0] || (_cache[0] = _createElementVNode("span", { class: "df-impact__dot" }, null, -1 /* CACHED */)),
                    _createElementVNode("span", _hoisted_2, _toDisplayString(description.value), 1 /* TEXT */)
                ]))
                : _createCommentVNode("v-if", true);
        };
    }
});
